import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ExploreRoundedIcon from "@mui/icons-material/ExploreRounded";
import CasinoRoundedIcon from "@mui/icons-material/CasinoRounded";
import SportsSoccerRoundedIcon from "@mui/icons-material/SportsSoccerRounded";
import ForumRoundedIcon from "@mui/icons-material/ForumRounded";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
import { useAuth } from "../auth/AuthContext";
import { openAuth } from "../utils/authBus";

const MobileNav = ({ onBrowse }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  const path = location.pathname;

  const items = [
    {
      key: "browse",
      label: "Gözat",
      icon: <ExploreRoundedIcon />,
      action: () => onBrowse?.(),
    },
    {
      key: "casino",
      label: "Casino",
      icon: <CasinoRoundedIcon />,
      active: path === "/" || path === "/games" || path.startsWith("/oyna"),
      action: () => navigate("/"),
    },
    {
      key: "sport",
      label: "Spor",
      icon: <SportsSoccerRoundedIcon />,
      active: path.startsWith("/spor") || path.startsWith("/iddaa"),
      action: () => navigate("/spor"),
    },
    {
      key: "chat",
      label: "Sohbet",
      icon: <ForumRoundedIcon />,
      action: () => window.dispatchEvent(new Event("marsilya-open-chat")),
    },
    {
      key: "profile",
      label: user ? "Profil" : "Giriş",
      icon: <PersonRoundedIcon />,
      active: path.startsWith("/hesabim") || path.startsWith("/profil") || path === "/login",
      action: () => (user ? navigate("/hesabim") : openAuth("login")),
    },
  ];

  return (
    <nav className="mnav" aria-label="Alt gezinti">
      {items.map((item) => (
        <button
          key={item.key}
          type="button"
          className={item.active ? "on" : ""}
          onClick={item.action}
          aria-label={item.label}
        >
          {item.icon}
          <span>{item.label}</span>
        </button>
      ))}
    </nav>
  );
};

export default MobileNav;
